module.exports = __webpack_public_path__ + "static/media/S1N10-4.5bb5d1aa.svg";